const TAILWIND_COLORS: Record<string, string> = {
  lightGray: "#f5f6f8",
  darkGray: "#7B8894",
};

const getThemeColor = (color: string): string | undefined => {
  return TAILWIND_COLORS[color];
};

export { getThemeColor };
